<template>
  <v-select
    v-bind="computedProps"
    v-on="computedListeners"
    solo
    flat
    :placeholder="phtext"
    :tabindex="readonly ? -1 : 0"
    @blur="onBlur"
    @focus="onFocus"
    @keydown.enter="onKeydownEnter"
    @keydown.tab="onKeydownTab"
    @keydown.esc="onKeydownEsc"
  >
    <template v-slot:label v-if="label !== undefined && label !== null && label !== ''">
      {{ label }}
      <span v-if="required" class="mandatory">必須</span>
    </template>
  </v-select>
</template>
<script>
import controls from '@/rahmen/controls'
import validators from '@/rahmen/validators'
import inputMixin from '@/mixins/inputMixins'
import { VSelect } from 'vuetify/lib'

/**
 * @file DDv2用単一ドロップダウン
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [required=false] - 必須有無
 * @vue-prop {String} [errorMessages=''] - エラーメッセージ
 * @see https://vuetifyjs.com/ja/api/v-select/
 * @example
  <dd-drop-down
    v-model="dropdown1value"
    :items="dropDownItems"
    :required="true"
    />
  data: () => ({
    dropDownItems: [
      { value: null, text: '' },
      { value: '0', text: 'Windows 3.1' },
      { value: '1', text: 'Windows 95' },
      { value: '2', text: 'Windows 98' },
      { value: '3', text: 'Windows 98 SE' },
      { value: '4', text: 'Windows 2000' },
      { value: '5', text: 'Windows Me' },
      { value: '6', text: 'Windows XP' },
      { value: '7', text: 'Windows Vista' },
      { value: '8', text: 'Windows 8' },
      { value: '9', text: 'Windows 10' }
    ]
  })
 */
export default {
  name: 'DdSpreadSheetDropDown',
  extends: VSelect,
  mixins: [inputMixin],
  props: {
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String
  },
  data: () => ({
    phtext: '選択して下さい',
    invalidMessage: ''
  }),
  created () {
  },
  mounted () {
    console.log(this.$props)
    this.invalidMessage = this.errorMessages
  },
  computed: {
    computedProps () {
      return {
        ...this.$props,
        // backgroundColor: this.required ? controls.Colors.Required : '',
        class: this.required ? ' required-item' : this.class,
        hideDetails: 'auto',
        dense: true,
        multiple: false,
        error: this.hasError,
        errorMessages: this.invalidMessage,
        itemText: controls.SelectTextPropName,
        itemValue: controls.SelectValuePropName
      }
    },
    computedListeners () {
      return {
        ...this.$listeners,
        blur: e => this.onBlur(e)
      }
    },
    hasError () {
      return this.invalidMessage !== '' && this.invalidMessage !== undefined
    }
  },
  methods: {
    onInput: function (e) {
      this.inputValue = e
    },
    onBlur: function (e) {
      this[controls.VALIDATE_METHOD]()
      if (!this.hasError) {
        this[controls.FORMAT_METHOD]()
      }
    },
    onFocus: function (e) {
      console.log('DdCodeTextBox.onFocus', e)
      if (typeof this.appendUnFormatter === 'function' && this.appendUnFormatter) {
        this.innerValue = this.appendUnFormatter(this.innerValue)
      }
      const elem = this.$el.querySelector('input')
      this.$nextTick().then(() => {
        if (elem) { elem.select() }
        this.$emit('focus', e)
      })
    },
    onKeydownEnter: function (e) {
      console.log('onKeydownEnter')
      this.$emit('enter', e)
    },
    onKeydownTab: function (e) {
      console.log('onKeydownTab')
      this.$emit('tab', e)
    },
    onKeydownEsc: function (e) {
      console.log('onKeydownEsc')
      this.$emit('esc', e)
    },
    [controls.VALIDATE_METHOD]: function () {
      const target = {
        value: this.value,
        length: this.length
      }

      this.invalidMessage = undefined
      const validatorList = []

      if (this.required) { validatorList.unshift(validators.requireValidate) }
      if (this.appendValidators) { validatorList.push(...this.appendValidators) }

      for (let i = 0; i < validatorList.length; i++) {
        const f = validatorList[i]
        const ret = f(target)
        if (ret !== undefined) {
          this.invalidMessage = ret
          return
        }
      }
    },
    [controls.FORMAT_METHOD]: function () {
    }
  }
}
</script>
<style scoped>
::v-deep .v-select__selections input {
  max-width: 0px;
  max-height: 0px;
}
</style>
